module.exports = __webpack_public_path__ + "static/media/dk.7e13e538.svg";